import React from 'react';

import { COMPANY_INFO } from '../../../constants/routes';
import { Link, Button, Translation, Modal } from '../../common';

export default ({ open, styles, onOkClick }) => (
  <Modal isOpen={open} paperClassName={styles['cookie-agreement__wrapper']}>
    <div className={styles['cookie-agreement']}>
      <div className={styles['cookie-agreement__content']}>
        <Translation inline>COOKIE_BANNER_TEXT</Translation>
        <span> </span>
        <Link
          id="page.component.cookie-agreement.cookie-link"
          className={styles['cookie-agreement__link']}
          to={COMPANY_INFO}
        >
          <Translation inline>COOKIE_BANNER_LINK</Translation>
        </Link>
      </div>
      <Button
        id="page.component.cookie-agreement.ok-button"
        className={styles['cookie-agreement__agree']}
        onClick={onOkClick}
        fullWidth
      >
        <Translation>COOKIE_BANNER_BUTTON</Translation>
      </Button>
    </div>
  </Modal>
);
